@let tabsList = tabsSg();
@let selectedTab = selectedTabSg();
@let selectedIndex = selectedIndexSg();
@let disabled = disabledSg();

<div class="ds-page-top-tabs">
  <div class="ds-page-top-tabs__header-links">
    @for (tab of tabsList; track $index) {
      <div
        data-test-id="header-tabs"
        class="ds-page-top-tabs__header-link"
        [class.ds-page-top-tabs__header-link--selected]="selectedTab === tab"
        (click)="
          !(disabled || tab.disabledSg()) &&
            selectedIndex !== $index &&
            onTabClickHandler($index)
        "
      >
        {{ tab.nameSg() }}
      </div>
    }
  </div>
  @if (selectedTab) {
    <div class="ds-page-top-tabs__content">
      <ng-container *ngTemplateOutlet="selectedTab?.template ?? null" />
    </div>
  }
</div>
